import { isErrorMobile100 } from "@/component/PageComponentMobile/error"
import { serviceFilterDeliverType,ServiceFilterDeliverType } from './serviceDeliverType'
import { LabelItem } from "../Common/LabelItem"
import { FilterList } from "../Common/FilterList"
import React from 'react'
import { useRequest } from "ahooks"

interface FilterDeliverTypeProps {
  placeholder: string
  onChange(value:any[]):void
  value?:any[]
}

export const FilterDeliverType = (props:FilterDeliverTypeProps)=>{
  const { placeholder } = props
  const [data,setData] = React.useState<ServiceFilterDeliverType['data']['list']>()
  const [visible,setVisible] = React.useState(false)
  
  let {run:getDeliverrType,loading} = useRequest(async()=>{
    let res = await serviceFilterDeliverType()
    if(isErrorMobile100(res)){
      return
    }
    setData(res.data.data.list)
  },{manual:true})
  React.useEffect(()=>{
    if(visible){
      getDeliverrType()
    }
  },[visible])
  let dataSource = data?.map(item=>({label:item.name,value:item.id}))
  return <div>
    <LabelItem
      label={placeholder}
      value={ props.value}    
      options={dataSource}
      onClick={()=>setVisible(true)} 
    ></LabelItem>
    <FilterList
      visible={visible}
      loading={loading}
      value={props.value}
      headerText={placeholder}
      dataSource={dataSource || []}
      onChange={props.onChange}
      onClose={ ()=>setVisible(false) }
    />
  </div>
}